/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import React from 'react';
import { css } from 'aphrodite';
import { MaterialIcon } from '@blend/enterprise-components';
import { mixins } from '@blend/consumer-components';
import { useConsumerTheme, ConsumerAppConfigContext } from '../../../hooks/useConsumerTheme';

export namespace IconButton {
  export interface Props {
    icon: MaterialIcon.Props['type'];
    onClick: () => void;
  }
}

const generateStyles = (appConfig: ConsumerAppConfigContext) => ({
  iconButton: {
    padding: 0,
    border: 'none',
    background: 'none',
    backgroundColor: appConfig.colors.action,
    boxShadow: mixins.boxShadow(0, 2, 4, 0, mixins.fade(appConfig.colors.black, 0.2)),
    width: 40,
    height: 40,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export const IconButton: React.FC<IconButton.Props> = ({ icon, onClick }) => {
  const {
    appConfig: { colors },
    styles,
  } = useConsumerTheme(generateStyles);
  return (
    <button className={css(styles.iconButton)} onClick={onClick} data-it="IconButton">
      <MaterialIcon color={colors.white} size={22} type={icon} />
    </button>
  );
};
